
export default function Terms() {
  const styles = {
    content: {
      maxWidth: 800,
      margin: '0 auto',
    },
    section: {
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: 32,
      marginBottom: 24,
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    title: {
      fontSize: 32,
      fontWeight: 800,
      marginBottom: 8,
    },
    lastUpdated: {
      fontSize: 14,
      opacity: 0.8,
      marginBottom: 32,
    },
    subtitle: {
      fontSize: 20,
      fontWeight: 700,
      marginTop: 24,
      marginBottom: 12,
    },
    text: {
      fontSize: 16,
      lineHeight: 1.8,
      opacity: 0.95,
      marginBottom: 16,
    },
  };

  return (
    <div style={styles.content}>
      <h1 style={styles.title}>Terms & Conditions</h1>
      <p style={styles.lastUpdated}>Last Updated: January 8, 2026</p>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>1. Acceptance of Terms</h2>
        <p style={styles.text}>
          By installing and using Inbox Sentinel ("the Service"), you agree to be bound by these
          Terms and Conditions. If you do not agree to these terms, do not install or use the Service.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>2. Description of Service</h2>
        <p style={styles.text}>
          Inbox Sentinel is an automated spam filtering application that:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Analyzes inbound email conversations for spam characteristics</li>
          <li>Automatically removes high-confidence spam messages</li>
          <li>Deletes or flags spam-related contacts as configured</li>
          <li>Operates in real-time without storing customer data externally</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>3. User Responsibilities</h2>
        <p style={styles.text}>
          You agree to:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Provide accurate information during installation</li>
          <li>Maintain the security of your account credentials</li>
          <li>Review filtered content periodically to ensure accuracy</li>
          <li>Report any false positives or filtering issues to support</li>
          <li>Comply with all applicable laws and the platform's Terms of Service</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>4. Permissions and Access</h2>
        <p style={styles.text}>
          By installing Inbox Sentinel, you grant us permission to:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Read inbound conversations in your inbox</li>
          <li>Delete messages identified as spam</li>
          <li>Modify or delete contacts associated with spam messages</li>
          <li>Access location information to scope filtering</li>
        </ul>
        <p style={styles.text}>
          These permissions are used solely to provide the spam filtering service.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>5. Service Limitations</h2>
        <p style={styles.text}>
          <strong>No Guarantee of Perfect Filtering:</strong> While we strive for high accuracy,
          Inbox Sentinel cannot guarantee 100% spam detection or zero false positives. Automated
          filtering may occasionally misclassify legitimate emails as spam or miss some spam messages.
        </p>
        <p style={styles.text}>
          <strong>Availability:</strong> We aim for high availability but do not guarantee uninterrupted
          service. The Service may be temporarily unavailable due to maintenance, updates, or technical issues.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>6. Limitation of Liability</h2>
        <p style={styles.text}>
          To the maximum extent permitted by law, Inbox Sentinel and its operators shall not be liable for:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Lost business opportunities due to filtered messages</li>
          <li>False positives or missed spam</li>
          <li>Indirect, incidental, or consequential damages</li>
          <li>Any damages arising from use or inability to use the Service</li>
        </ul>
        <p style={styles.text}>
          You use the Service at your own risk and agree to review filtered content regularly.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>7. Data and Privacy</h2>
        <p style={styles.text}>
          Our use of your data is governed by our Privacy Policy. By using the Service, you consent
          to our data practices as described in the Privacy Policy.
        </p>
        <p style={styles.text}>
          Inbox Sentinel does not store email content or contact information externally. All filtering
          happens in real-time, and data is discarded after processing.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>8. Termination</h2>
        <p style={styles.text}>
          You may terminate your use of the Service at any time by uninstalling Inbox Sentinel from
          your account. Upon termination:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>All filtering will stop immediately</li>
          <li>Stored OAuth tokens will be deleted</li>
          <li>No further data will be accessed</li>
        </ul>
        <p style={styles.text}>
          We reserve the right to suspend or terminate access to the Service if you violate these terms
          or engage in abusive behavior.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>9. Modifications to Terms</h2>
        <p style={styles.text}>
          We reserve the right to modify these Terms and Conditions at any time. Material changes will
          be communicated through the Marketplace or by email. Continued use of the Service
          after changes constitutes acceptance of the modified terms.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>10. Intellectual Property</h2>
        <p style={styles.text}>
          All intellectual property rights in the Service, including software, algorithms, and documentation,
          remain the property of Inbox Sentinel and its licensors.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>11. Governing Law</h2>
        <p style={styles.text}>
          These Terms and Conditions shall be governed by and construed in accordance with the laws
          of the jurisdiction in which Inbox Sentinel operates, without regard to conflict of law principles.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>12. Contact Information</h2>
        <p style={styles.text}>
          For questions about these Terms and Conditions, contact us:
        </p>
        <p style={styles.text}>
          Email: <a href="mailto:inbox.sentinel@hello.miltonecom.com" style={{ color: '#fff' }}>inbox.sentinel@hello.miltonecom.com</a><br />
          Phone: +1 (866) 259-3033<br />
          Support: <a href="/support" style={{ color: '#fff' }}>Inbox Sentinel Support</a>
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>13. Entire Agreement</h2>
        <p style={styles.text}>
          These Terms and Conditions, together with the Privacy Policy, constitute the entire agreement
          between you and Inbox Sentinel regarding the use of the Service.
        </p>
      </div>
    </div>
  );
}
